<template>
    <div>
        <div class="form-row col-12 px-0">
            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Od'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Do'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
        </div>

        <div class="form-group">
            <input class="custom-radio" type="radio" name="client_type" :value="0" id="librariesSelected"
                   v-model="clientType" :disabled="radioDisabled">
            <label  for="librariesSelected"><span class="mr-3">{{ $lang('Biblioteki') }}</span></label>
            <input class="custom-radio" type="radio" name="client_type" :value="1" id="consortiumSelected"
                   v-model="clientType" :disabled="radioDisabled">
            <label  for="consortiumSelected"><span>{{ $lang('Konsorcjum') }}</span></label>

            <multiselect
                v-if="clientType===0"
                :searchable=true :close-on-select=false :disabled="selectedConsortium>0"
                id="libraries" v-model="selectedLibraries" :options="allLibraries"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz biblioteki')"
                :selectLabel="$lang('Wybierz bibliotekę')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń biblioteki')"
                :selectGroupLabel="$lang('Wybierz wszystkie biblioteki')"
                :deselectGroupLabel="$lang('Usuń wszystkie biblioteki')"
            ></multiselect>
            <input v-for="library in selectedLibraries" name="libraries[]" :value="library.id" hidden>

            <select v-if="clientType===1" id="consortium" name="consortium" class="form-control"
                    v-model="selectedConsortium" :disabled="selectedLibraries.length>0">
                <option :value=0>{{$lang('Wybierz konsorcjum')}}</option>
                <option v-for="consortium in consortiums" :value="consortium.id">{{consortium.name}}</option>
            </select>
        </div>

        <div class="form-group">
            <label for="statuses">{{$lang('Statusy')}}</label>
            <multiselect
                :searchable=false :close-on-select=false
                id="statuses" v-model="selectedStatuses" :options="allStatuses"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz statusy')"
                :selectLabel="$lang('Wybierz status')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń status')"
                :selectGroupLabel="$lang('Wybierz wszystkie statusy')"
                :deselectGroupLabel="$lang('Usuń wszystkie statusy')"
            ></multiselect>

            <input v-for="status in selectedStatuses" name="statuses[]" :value="status.id" hidden>
        </div>

        <div class="form-group">
            <label for="criteria">{{$lang('Kryteria')}}</label>
            <multiselect
                :searchable=false :close-on-select=false
                id="criteria" v-model="selectedCriteria" :options="allCriteria"
                group-values="options" group-label="label" :group-select="true"
                :multiple="true" label="name" track-by="id"
                :placeholder="$lang('Wybierz kryteria')"
                :selectLabel="$lang('Wybierz kryterium')"
                :selectedLabel="$lang('Wybrane')"
                :deselectLabel="$lang('Usuń kryterium')"
                :selectGroupLabel="$lang('Wybierz wszystkie kryteria')"
                :deselectGroupLabel="$lang('Usuń wszystkie kryteria')"
            ></multiselect>

            <input v-for="criterion in selectedCriteria" name="criteria[]" :value="criterion.id" hidden>
        </div>

        <div class="form-group mb-2">
            <div class="mb-2">{{$lang('Wyświetlaj zgłaszającego jako:')}}</div>
            <div class="ml-3">
                <input class="custom-radio" type="radio" name="notifier" :value="'library'" id="librarySelected"
                       v-model="notifier">
                <label  for="librarySelected"><span class="mr-3">{{ $lang('Bibliotekę') }}</span></label>
                <input class="custom-radio" type="radio" name="notifier" :value="'person'" id="personSelected"
                       v-model="notifier">
                <label  for="personSelected"><span>{{ $lang('Osobę') }}</span></label>
            </div>
        </div>

        <div class="form-group">
            <div class="mb-2">{{$lang('Czy liczyć czasy dla wszystkich kryteriów?')}}</div>
            <div class="ml-3">
                <input class="custom-radio" type="radio" name="countTimeForAll" :value="1" id="countForAll"
                       v-model="countTimeForAll">
                <label  for="countForAll"><span class="mr-3">{{ $lang('Tak') }}</span></label>
                <input class="custom-radio" type="radio" name="countTimeForAll" :value="0" id="dontCountForAll"
                       v-model="countTimeForAll">
                <label  for="dontCountForAll"><span>{{ $lang('Nie') }}</span></label>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ValidDate from "../../../mixins/report-valid-date";

export default {
    name: "maintenance-service-summary-inputs",
    components: {Multiselect},
    mixins: [ValidDate],
    props: [
        'libraries',
        'consortiums',
        'statuses',
        'criteria',
    ],
    data() {
        return {
            selectedLibraries: [],
            selectedConsortium: 0,
            selectedCriteria: [],
            selectedStatuses: [],
            clientType: 0,
            notifier: 'library',
            countTimeForAll: 0,
            allLibraries: [{
               label: 'Wszystkie',
               options: this.libraries
            }],
            allStatuses: [{
                label: 'Wszystkie',
                options: this.statuses
            }],
            allCriteria: [{
                label: 'Wszystkie',
                options: this.criteria
            }]
        }
    },
    computed: {
        valid() {
            return (this.selectedLibraries.length > 0 || this.selectedConsortium > 0) && this.selectedCriteria.length > 0 && this.selectedStatuses.length > 0
                && this.dateFrom !== '-' && this.dateTo !== '-' && this.dateFrom <= this.dateTo;
        },
        radioDisabled() {
            return this.selectedConsortium > 0 || this.selectedLibraries.length > 0;
        }
    },
    watch: {
        valid() {
            this.$emit('validation', this.valid);
        },
        selectedConsortium() {
            if (this.selectedConsortium > 0) {
                this.selectedLibraries = [];

            }
        },
        selectedLibraries() {
            if (this.selectedLibraries.length > 0) {
                this.selectedConsortium = 0;
            }
        }
    },
    created() {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth()-1, 1);
        const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
        this.dateFrom = firstDay.getFullYear() + '-' + ('0' + (firstDay.getMonth() + 1)).slice(-2) + '-' + ('0' + firstDay.getDate()).slice(-2);
        this.dateTo = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);
    }
}
</script>

<style scoped>

</style>
